import { getAccessToken } from '@/shared/auth';
import { appConfig } from '@/shared/config';

/**
 * Загрузка двоичного содержимого — картинок из медиатеки.
 *
 * Обычный клиент сюда не годится: он читает ответ как текст и требует JSON,
 * потому что весь остальной API отвечает именно им.
 *
 * А `<img src>` не годится потому, что медиатека не публична: файл отдаётся с
 * тем же токеном, что и всё прочее, а тег картинки заголовок Authorization
 * поставить не умеет. Поэтому содержимое забирается запросом и превращается в
 * blob-ссылку.
 *
 * Плата честная: такие ссылки живут в памяти вкладки и не делятся между
 * страницами, то есть браузерный кеш здесь не работает. Поэтому превью
 * приходят готовыми подписанными адресами (thumb_url) и показываются
 * обычным <img> — а этот путь остался для того, у чего подписи нет.
 */
export async function fetchBlobURL(path: string, signal?: AbortSignal): Promise<string> {
  const token = getAccessToken();

  const response = await fetch(withBase(path), {
    ...(signal === undefined ? {} : { signal }),
    headers: token === null ? {} : { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    throw new Error(`не удалось загрузить файл: ${response.status}`);
  }

  return URL.createObjectURL(await response.blob());
}

/**
 * Полный адрес пути API — для подписанных ссылок (mediaPlayback), которые
 * ставятся прямо в `<video src>` и `<img src>`: токен им не нужен.
 */
export function apiPath(path: string): string {
  return withBase(path);
}

/** Приставка адреса API — та же, что у остального клиента. */
function withBase(path: string): string {
  return `${appConfig.apiBaseUrl.replace(/\/$/, '')}${path}`;
}
